
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import fileDownload from 'js-file-download';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import {
    DatePicker, Form, Button, Icon, Tag
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport, faSearch } from '@fortawesome/free-solid-svg-icons';

import {
    cashlessRemittedList,
    cashlessRemittednonFilterList,
    cashlessUnRemittedViewsAccount,
} from './ducks';

import { fetchOptions } from './ducks';

import PageHeader from '../../components/PageHeader';
import ReactTable from '../../components/ServerSideTable';
import Card from '../../components/Card';
import Container from '../../components/Container';
import Spacer from '../../components/Spacer';
import ReactSelect from '../../components/Select';

export class List extends Component {
    constructor(props) {
        super(props);

        const todayStart = moment().startOf('day');
        const todayEnd = moment().endOf('day');

        this.state = {
            handoverDate: [
                {
                    id: 'dateFrom',
                    value: todayStart.format('YYYY-MM-DD HH:mm'),
                },
                {
                    id: 'dateTo',
                    value: todayEnd.format('YYYY-MM-DD HH:mm'),
                },
            ],

            loading: true,

            userData: {
                rows: [],
                pages: 0,
                total: 0,
            },

            payloadReq: {
                page: 0,
                pageSize: 10,
                filter: [],
                sorted: [],
            },

            tableFilter: [],
            searchFilter: [],

            optionState: {
                destination: [],
            },

            dispatchLocation: null,
            isFetchingSelect: false,
        };

        this.onFetchDataFunc = this.onFetchDataFunc.bind(this);

        // Debounce search function to reduce unnecessary API calls
        this.handleSearchLocation = debounce(
            this.handleSearchLocation.bind(this),
            400
        );
    }

    componentDidMount() {
        this.fetchLocationOptions('');
    }

    fetchLocationOptions(query = '') {
        const { doRubixpickOptions } = this.props;

        this.setState({
            isFetchingSelect: true,
        });

        doRubixpickOptions('destination', query)
            .then(res => {
                const options =
                    res &&
                    res.payload &&
                    res.payload.data
                        ? res.payload.data.slice(0, 50)
                        : [];

                this.setState({
                    optionState: {
                        destination: options,
                    },
                    isFetchingSelect: false,
                });
            })
            .catch(() => {
                this.setState({
                    isFetchingSelect: false,
                });
            });
    }

    handleSearchLocation(value) {
        console.log(value);
        this.fetchLocationOptions(value);
    }

    onDispatchLocationChange(value) {
        this.setState({
            dispatchLocation: value,
        });
    }

    onFetchDataFunc(state, instance) {
        const {
            handoverDate,
            tableFilter,
            dispatchLocation,
        } = this.state;

        const { nonFilterList } = this.props;

        if (handoverDate.length !== 2) {
            return;
        }

        this.setState({
            loading: true,
        });

        /*
         * IMPORTANT:
         * Use the state passed by ReactTable instead of
         * payloadReq for page, pageSize and sorted.
         */
        const paramsReq = {
            export: false,
            page: state.page,
            pageSize: state.pageSize,
            filter: [...handoverDate],
            sorted: state.sorted || [],
        };

        if (dispatchLocation) {
            paramsReq.filter.push({
                id: 'location',
                value: dispatchLocation,
            });
        }

        if (tableFilter.length) {
            paramsReq.filter = paramsReq.filter.concat(tableFilter);
        }

        nonFilterList(paramsReq)
            .then(res => {
                this.setState({
                    loading: false,

                    userData: {
                        rows: res.payload.data.rows,
                        pages: res.payload.data.pages,
                        total: res.payload.data.total,
                    },

                    payloadReq: paramsReq,

                    searchFilter: [
                        ...handoverDate,
                        ...(dispatchLocation
                            ? [
                                {
                                    id: 'location',
                                    value: dispatchLocation,
                                },
                            ]
                            : []),
                    ],
                });
            })
            .catch(() => {
                this.setState({
                    loading: false,
                });
            });
    }

    getEditAccountHandler(e) {
        const { history } = this.props;

        history.push(`/cashless-remittance/${e.dm}`);
    }

    submitHandler() {
        const {
            payloadReq,
            handoverDate,
            tableFilter,
            dispatchLocation,
        } = this.state;

        const { nonFilterList } = this.props;

        if (handoverDate.length !== 2) {
            return;
        }

        this.setState({
            loading: true,
        });

        /*
         * Keep the currently selected pageSize.
         * Reset page to 0 when applying a new filter.
         */
        const paramsReq = {
            export: false,
            page: 0,
            pageSize: payloadReq.pageSize || 10,
            filter: [...handoverDate],
            sorted: payloadReq.sorted || [],
        };

        if (dispatchLocation) {
            paramsReq.filter.push({
                id: 'location',
                value: dispatchLocation,
            });
        }

        if (tableFilter.length) {
            paramsReq.filter = paramsReq.filter.concat(tableFilter);
        }

        nonFilterList(paramsReq)
            .then(res => {
                this.setState({
                    loading: false,

                    userData: {
                        rows: res.payload.data.rows,
                        pages: res.payload.data.pages,
                        total: res.payload.data.total,
                    },

                    payloadReq: paramsReq,

                    searchFilter: [
                        ...handoverDate,
                        ...(dispatchLocation
                            ? [
                                {
                                    id: 'location',
                                    value: dispatchLocation,
                                },
                            ]
                            : []),
                    ],
                });
            })
            .catch(() => {
                this.setState({
                    loading: false,
                });
            });
    }

    submitHandlerExportDetails() {
        const {
            payloadReq,
            handoverDate,
            dispatchLocation,
        } = this.state;

        const { nonFilterList } = this.props;

        if (handoverDate.length !== 2) {
            return;
        }

        this.setState({
            loading: true,
        });

        const paramsReq = {
            export: false,
            export_details: true,
            page: payloadReq.page,
            pageSize: payloadReq.pageSize || 10,
            filter: [
                ...handoverDate,
                ...(dispatchLocation
                    ? [
                        {
                            id: 'location',
                            value: dispatchLocation,
                        },
                    ]
                    : []),
            ],
            sorted: payloadReq.sorted || [],
        };

        nonFilterList(paramsReq)
            .then(res => {
                const newBlob = new Blob([res.payload.data]);

                fileDownload(
                    newBlob,
                    'Remittance-details.csv'
                );

                this.setState({
                    loading: false,
                });
            })
            .catch(() => {
                this.setState({
                    loading: false,
                });
            });
    }

    submitHandlerExport() {
        const {
            payloadReq,
            handoverDate,
            dispatchLocation,
        } = this.state;

        const { nonFilterList } = this.props;

        if (handoverDate.length !== 2) {
            return;
        }

        this.setState({
            loading: true,
        });

        const paramsReq = {
            export: true,
            page: payloadReq.page,
            pageSize: payloadReq.pageSize || 10,
            filter: [
                ...handoverDate,
                ...(dispatchLocation
                    ? [
                        {
                            id: 'location',
                            value: dispatchLocation,
                        },
                    ]
                    : []),
            ],
            sorted: payloadReq.sorted || [],
        };

        nonFilterList(paramsReq)
            .then(res => {
                const newBlob = new Blob([res.payload.data]);

                fileDownload(
                    newBlob,
                    'Remittance-list.csv'
                );

                this.setState({
                    loading: false,
                });
            })
            .catch(() => {
                this.setState({
                    loading: false,
                });
            });
    }

    dateHandler(dateStrings) {
        if (
            !dateStrings ||
            !dateStrings[0] ||
            !dateStrings[1]
        ) {
            this.setState({
                handoverDate: [],
            });

            return;
        }

        const newDateOne = dateStrings[0];
        const newDateTwo = dateStrings[1];

        this.setState({
            handoverDate: [
                {
                    id: 'dateFrom',
                    value: newDateOne.format(
                        'YYYY-MM-DD HH:mm'
                    ),
                },
                {
                    id: 'dateTo',
                    value: newDateTwo.format(
                        'YYYY-MM-DD HH:mm'
                    ),
                },
            ],
        });
    }

    render() {
        const {
            userData,
            loading,
            handoverDate,
            optionState,
            isFetchingSelect,
            dispatchLocation,
        } = this.state;

        const breadCrumbs = [
            {
                breadcrumbName: 'Cashless Remittance',
            },
            {
                breadcrumbName: 'List',
            },
        ];

        return (
            <div className="List">

                <PageHeader
                    title="REMITTANCE LIST"
                    routes={breadCrumbs}
                />

                <Spacer />

                <Container>

                    <Form>

                        <Card>

                            <Form.Item
                                label="Dispatch Date"
                                required
                            >
                                <DatePicker.RangePicker
                                    style={{
                                        width: '100%',
                                    }}

                                    defaultValue={[
                                        moment().startOf('day'),
                                        moment().endOf('day'),
                                    ]}

                                    showTime={{
                                        hideDisabledOptions: true,

                                        defaultValue: [
                                            moment(
                                                '00:00',
                                                'HH:mm'
                                            ),
                                            moment(
                                                '23:59:59',
                                                'HH:mm'
                                            ),
                                        ],
                                    }}

                                    format="YYYY-MM-DD HH:mm:ss"

                                    onChange={e =>
                                        this.dateHandler(e)
                                    }
                                />
                            </Form.Item>

                            <Form.Item label="Dispatch Location">
                                <ReactSelect
                                    allowClear
                                    showSearch
                                    filterOption={false}
                                    loading={isFetchingSelect}
                                    value={dispatchLocation}
                                    onSearch={val =>
                                        this.handleSearchLocation(
                                            val
                                        )
                                    }
                                    onChange={value =>
                                        this.onDispatchLocationChange(
                                            value
                                        )
                                    }
                                    style={{
                                        width: '100%',
                                    }}
                                    placeholder="Select Destination..."
                                    options={
                                        optionState.destination
                                    }
                                />
                            </Form.Item>

                            <Button
                                onClick={() =>
                                    this.submitHandler()
                                }
                                type="primary"
                                block
                                disabled={
                                    handoverDate.length !== 2
                                }
                            >
                                <Icon viewBox="0 0 1024 1024">
                                    <FontAwesomeIcon
                                        icon={faSearch}
                                        fixedWidth
                                    />
                                </Icon>

                                Filter
                            </Button>

                        </Card>

                        <Spacer />

                        <Card
                            title={(
                                <div>

                                    <Button
                                        onClick={() =>
                                            this.submitHandlerExport()
                                        }
                                        type="danger"
                                        style={{
                                            marginRight: 8,
                                        }}
                                    >
                                        <Icon viewBox="0 0 1024 1024">
                                            <FontAwesomeIcon
                                                icon={faFileExport}
                                                fixedWidth
                                            />
                                        </Icon>

                                        Export
                                    </Button>

                                    <Button
                                        onClick={() =>
                                            this.submitHandlerExportDetails()
                                        }
                                        type="primary"
                                    >
                                        <Icon viewBox="0 0 1024 1024">
                                            <FontAwesomeIcon
                                                icon={faFileExport}
                                                fixedWidth
                                            />
                                        </Icon>

                                        Export Details
                                    </Button>

                                </div>
                            )}

                            extra={`Total: ${userData.total
                                .toString()
                                .replace(
                                    /\B(?=(\d{3})+(?!\d))/g,
                                    ','
                                )}`}
                        >

                            <ReactTable
                                data={userData.rows}
                                pages={userData.pages}

                                columns={[

                                    {
                                        Header: 'Date',
                                        accessor: 'created_date',
                                    },

                                    {
                                        Header: 'DM',
                                        accessor: 'dm',
                                    },

                                    {
                                        Header: 'Driver',
                                        accessor: 'driver',
                                    },

                                    {
                                        Header: 'Bank Ref',
                                        accessor: 'bank_ref',
                                    },

                                    {
                                        Header: 'Bank Name',
                                        accessor: 'bank_name',
                                    },

                                    {
                                        Header: 'Amount',
                                        accessor: 'total_amount',
                                    },

                                    {
                                        Header: 'Status',
                                        accessor: 'status',

                                        Cell: ({ value }) => (
                                            <Tag
                                                color={
                                                    value ===
                                                    'completed'
                                                        ? '#87d068'
                                                        : '#F69F3D'
                                                }
                                            >
                                                {value
                                                    .charAt(0)
                                                    .toUpperCase()
                                                    + value.slice(1)}
                                            </Tag>
                                        ),
                                    },

                                    {
                                        Header: 'Options',
                                        sortable: false,
                                        filterable: false,

                                        Cell: row => (
                                            <center>

                                                <Button
                                                    type="link"
                                                    onClick={() =>
                                                        this.getEditAccountHandler(
                                                            row.original
                                                        )
                                                    }
                                                >
                                                    <Icon type="eye" />

                                                    View
                                                </Button>

                                            </center>
                                        ),
                                    },

                                ]}

                                loadingText="Fetching cashless remittance list. . ."

                                loading={loading}

                                onFetchData={
                                    this.onFetchDataFunc
                                }
                            />

                        </Card>

                    </Form>

                </Container>

            </div>
        );
    }
}

const mapStateToProps = state => ({
    courierList:
        state.courierRemittance.data,
});

const mapDispatchToProps = {
    requestcashlessRemittedList:
        cashlessRemittedList,

    nonFilterList:
        cashlessRemittednonFilterList,

    urViews:
        cashlessUnRemittedViewsAccount,

    doRubixpickOptions:
        fetchOptions,
};

List.propTypes = {
    nonFilterList:
        PropTypes.func.isRequired,

    doRubixpickOptions:
        PropTypes.func.isRequired,

    history: PropTypes.oneOfType([
        PropTypes.object,
    ]).isRequired,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(List);
